import { createTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const useStyles = makeStyles(theme => ({
  body: {
    padding: '130px 130px',
    maxWidth: '1400px',
    gap: '6px',
    [colortheme.breakpoints.down('md')]: {
      padding: '130px 50px',
    },
  },
  layer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  bigTitleText: {
    fontSize: '20px',
    color: '#ffffff',
    marginBottom: '10px',
  },
  mediumTitleText: {
    marginTop: '20px',
    marginBottom: '10px',
    fontSize: '16px',
    color: '#ffffff',
  },
  subText: {
    fontSize: '14px',
    color: '#c1c1c1',
  },
  divider: {
    marginTop: '40px',
    backgroundColor: '#c1c1c1',
  },
}));

export default useStyles;
